import { createApiResource, GetByIdResource } from '../apiResourceFactory';
import { API } from '../apiService';
import { AppointmentHistoryDetailDTO } from '../apiTypes.shim';

interface AppointmentHistoryResource extends GetByIdResource<AppointmentHistoryDetailDTO> {}

export const createAppointmentHistoryResource = (): AppointmentHistoryResource => {
  const appointmentHistoryResourceUri = `appointment-history`;

  const { getById, useGetById, getByIdQueryKey } = createApiResource(API, appointmentHistoryResourceUri);

  return {
    getById,
    useGetById,
    getByIdQueryKey
  };
};
